export const calculateDataType = (
	editType,
	dbType:
		| 'string'
		| 'boolean'
		| 'decimal'
		| 'int'
		| 'date'
		| 'dateTime'
		| 'time'
		| 'object'
		| 'none'
) => {
	switch (editType) {
		case 'checkBox':
			return 'boolean';
		case 'datePicker':
			return 'date';
		case 'dateTimePicker':
		case 'timePicker':
			return 'datetime';
		case 'numberBox':
			return 'number';
		case 'textBox':
		case 'multiLanguageTextBox':
		case 'fileSelect':
			return 'string';
		case 'comboBox':
			if (dbType === 'object') {
				return 'object';
			} else if (dbType === 'decimal') {
				return 'number';
			}

			return 'string';
		default:
			return 'object';
	}
};
